import { useMelwaysLink } from '@seek/melways-react';
import { useTranslations } from '@vocab/react';
import { Stack, TextLink, Text } from 'braid-design-system';
import { useContext } from 'react';
import { usePricingContext } from 'src/App/context/PricingContextProvider';
import { TrackingContext } from 'src/App/context/trackingContext';
import translations from './.vocab';

export const AdPricingDisclaimer = () => {
  const { isOnVariablePricing } = usePricingContext();
  const jobAdsPath = useMelwaysLink({ path: '/products/jobads' });
  const tracking = useContext(TrackingContext);
  const { t } = useTranslations(translations);

  return (
    <Stack space={'small'}>
      {isOnVariablePricing && (
        <Text>{t('ad prices may vary depending on...')}</Text>
      )}
      <Text>
        {t('For more information on ad types...', {
          TextLink: (v) => (
            <TextLink
              href={jobAdsPath}
              onClick={() => tracking.onProductLinkClicked()}
              target="_blank"
            >
              {v}
            </TextLink>
          ),
        })}
      </Text>
    </Stack>
  );
};
